/* eslint-disable import/no-cycle */
import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import Link from "../../../../LinkWithCountry/LinkWithCountry";
import amplitudeAnalytics, { AMPLITUDE_NAV_SECTION } from "../../../../../shared/utilities/amplitude";
import NavIcons from "../NavIcons/NavIcons";
import AddressSelector from "../AddressSelector/AddressSelector";
import useProminentNavigation from "../../../../ExperimentGate/useProminentNavigation";
import styles from "../NavigationBar.module.css";
import {
  getNavPartProps,
  isNavigationBarBrandRefresh,
} from "../navigationBarBrandRefreshClasses";

const RightSide = ({
  isLoggedIn,
  cartQuantity,
  userOrderMethod,
  selectedStore,
  userAddress,
  onToggleHeaderWidget,
  onOpenHeaderWidgetFromOrderNow,
  onToggleMobileMenu,
  showNotification,
  amountAdded,
  productAddedImagePath,
  isMenuPage,
}) => {
  const prominentNavigation = useProminentNavigation();
  const location = useLocation();
  const isBrandRefresh = isNavigationBarBrandRefresh();

  const ctaLabel = "Order Now";

  const trackNavClick = (navElement) => {
    amplitudeAnalytics.trackClickNavPrimary({
      navElement,
      navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
      pathname: location.pathname,
    });
  };

  const hasLocation =
    (userOrderMethod === "DELIVERY" && userAddress) ||
    (userOrderMethod === "PICKUP" && selectedStore);

  const handleOrderNowClick = (e) => {
    trackNavClick(ctaLabel);
    if (!hasLocation) {
      e.preventDefault();
      onOpenHeaderWidgetFromOrderNow();
    }
  };

  const addressControls = (
    <>
      <div
        className={isBrandRefresh ? "flex" : "hidden md:block"}
        data-part={getNavPartProps("address-selector")}
      >
        <AddressSelector
          prominentNavigation={prominentNavigation}
          userOrderMethod={userOrderMethod}
          selectedStore={selectedStore}
          userAddress={userAddress}
          onToggleHeaderWidget={onToggleHeaderWidget}
        />
      </div>

      {!isMenuPage && (
        <Link
          to="/menu"
          className={styles.orderNowButton}
          onClick={handleOrderNowClick}
          data-part={getNavPartProps("order-now-button")}
        >
          {isBrandRefresh ? (
            <div data-part={getNavPartProps("order-now-container")}>
              <span data-part={getNavPartProps("order-now-text")}>{ctaLabel}</span>
            </div>
          ) : (
            ctaLabel
          )}
        </Link>
      )}
    </>
  );

  return (
    <div
      className={
        isBrandRefresh
          ? styles.rightSide
          : `${styles.rightSide} flex items-center gap-2 flex-shrink-0`
      }
      data-part={getNavPartProps("right-side")}
    >
      {prominentNavigation ? (
        <div data-part="address-widget" className={styles.addressWidget}>
          {addressControls}
        </div>
      ) : addressControls}

      <NavIcons
        isLoggedIn={isLoggedIn}
        cartQuantity={cartQuantity}
        onToggleMobileMenu={onToggleMobileMenu}
        showNotification={showNotification}
        amountAdded={amountAdded}
        productAddedImagePath={productAddedImagePath}
        className={styles.navIconsWrapper}
      />
    </div>
  );
};

RightSide.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  cartQuantity: PropTypes.number.isRequired,
  userOrderMethod: PropTypes.string,
  selectedStore: PropTypes.shape({
    name: PropTypes.string,
  }),
  userAddress: PropTypes.shape({
    address1: PropTypes.string,
    savedLocation: PropTypes.shape({
      locationLabel: PropTypes.shape({
        label: PropTypes.string,
      }),
    }),
  }),
  onToggleHeaderWidget: PropTypes.func.isRequired,
  onOpenHeaderWidgetFromOrderNow: PropTypes.func.isRequired,
  onToggleMobileMenu: PropTypes.func.isRequired,
  showNotification: PropTypes.bool,
  amountAdded: PropTypes.number,
  productAddedImagePath: PropTypes.string,
  isMenuPage: PropTypes.bool,
};

RightSide.defaultProps = {
  userOrderMethod: "",
  selectedStore: null,
  userAddress: null,
  showNotification: false,
  amountAdded: 0,
  productAddedImagePath: null,
  isMenuPage: false,
};

export default RightSide;
